import { language, country } from "./ocm-object";

const defaultCurrency = country === "ch" ? "CHF" : "EUR";

export const formatPrice = (price: number | string, currencyIso = defaultCurrency) => {
	const _locale = currencyIso === "CHF" ? "de-CH" : "de-AT";
	return new Intl.NumberFormat(_locale, { style: "currency", currency: currencyIso, useGrouping: false }).format(
		Number(price)
	);
};

export const formatDiscount = (percentage: number | string) => `-${Math.floor(Math.abs(Number(percentage)))}%`;

const countryLocaleMap: Record<string, string> = { de: "de-DE", at: "de-AT", ch: "de-CH", int: "en" };
const numberFormatter = new Intl.NumberFormat(countryLocaleMap[country] ?? language);
export const formatNumber = (number: number | string) => numberFormatter.format(Number(number));
